import React, { useState } from "react";
import Form from "../../../../components/Form/Form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Button, { ButtonModeE } from "../../../../components/Button/Button";
import {
    useForgotPasswordByEmailMutation,
    useForgotPasswordByUserNameMutation,
} from "../../../../api/loginAPI";
import { ValidatorsE } from "../../../../components/Form/yupValidations";
import { RoutesE } from "../../../../routes/routesData";
import { H1, P, Span } from "../../../../components/Text/Text";
import { useTranslate } from "../../../../utils/hooks/useTranslate";
import { TOAST_DURATION } from "../../../../utils/helpers/constants";

import styles from "../../forgotPassword.module.scss";

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [forgotPasswordByUserName] = useForgotPasswordByUserNameMutation();
  const [forgotPasswordByEmail] = useForgotPasswordByEmailMutation();
  const [value, setValue] = React.useState("");
  const [resetType, setResetType] = useState("Email");
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslate();

  const handleSubmit = async () => {
    if (!value) {
      const triggerValidateEvent = new CustomEvent("triggerFields", {
        detail: {
          fieldNames: ["email"],
        },
      });
      const form = document.getElementById("dummy-form");
      form.dispatchEvent(triggerValidateEvent);
      return;
    }

    try {
      const res =
        resetType === "Email"
          ? await forgotPasswordByEmail({
              email: value,
            })
          : await forgotPasswordByUserName({
              username: value,
            });

      if ((res as any).data) {
        setIsSuccess(true);
        toast.success("Mail with password reset was sent", {
          autoClose: TOAST_DURATION,
        });
      } else {
        toast.error(
          resetType === "Email" ? t`Email not found` : t`User not found`,
          {
            autoClose: TOAST_DURATION,
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const navigateToLogin = () => {
    navigate(RoutesE.LOGIN);
  };

  const handleChangeResetType = (e) => {
    setResetType(e.target.value);
  };

  return !isSuccess ? (
    <div className={styles.forgotPasswordFormWrapper}>
      <H1>Forgot your password?</H1>
      <P className={styles.info}>Reset your password by</P>
      <div className={styles.selectTypeRadioGroup}>
        <div>
          <input
            type="radio"
            id="reset-by-email"
            value="Email"
            name="reset"
            onChange={handleChangeResetType}
            defaultChecked
          />
          <span className={styles.check}></span>
          <label htmlFor="reset-by-email">
            <Span>Email</Span>
          </label>
        </div>
        <div>
          <input
            type="radio"
            id="reset-by-username"
            value="User name"
            name="reset"
            onChange={handleChangeResetType}
          />
          <span className={styles.check}></span>
          <label htmlFor="reset-by-username">
            <Span>User name</Span>
          </label>
        </div>
      </div>
      <Form
        onSubmit={handleSubmit}
        fields={[
          {
            label: resetType,
            name: "email",
            onChange: (v) => setValue(v),
            validation:
              resetType === "Email"
                ? ValidatorsE.EMAIL
                : ValidatorsE.REQUIRED_STRING,
          },
        ]}
        formID="forgotPassword"
        columns={1}
      />
      <div className={styles.buttonsWrapper}>
        <Button useGlobalLoading form="forgotPassword">
          Reset password
        </Button>
        <Button
          onClick={navigateToLogin}
          mode={ButtonModeE.LINK}
          link={RoutesE.LOGIN}
        >
          Back
        </Button>
      </div>
    </div>
  ) : (
    <div className={styles.forgotPasswordFormWrapper}>
      <H1>Check your email</H1>
      <div className={styles.buttonsWrapper}>
        <Button
          onClick={navigateToLogin}
          mode={ButtonModeE.LINK}
          link={RoutesE.LOGIN}
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
